import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";

import { RootEntity, RootState } from "@types-runway/state";
import { User } from "@types-runway/user";

import AdminApp from "./AdminApp";
import { adminRoutePaths } from "./adminRoutes";

// Entry point App mounts at `/admin`, the rebuilt admin's own address outside
// the patient dashboard (XCUT-R17). This gate decides who gets in and nothing
// else: screens, state and theme belong to AdminApp.
const AdminGate = () => {
  const user = useSelector<RootState, RootEntity<User>>((state) => state.user);

  // Non-admins never see admin tools, even by address (FIND-R1).
  if (!user.data.isAdmin) {
    return <Redirect to={adminRoutePaths.nonAdminLanding} />;
  }

  return <AdminApp />;
};

export default AdminGate;
